import { render } from "./Restart.vue?vue&type=template&id=61181efd&scoped=true"
import script from "./Restart.vue?vue&type=script&lang=js"
export * from "./Restart.vue?vue&type=script&lang=js"

import "./Restart.vue?vue&type=style&index=0&id=61181efd&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-61181efd"

export default script